import { moment } from "components/tdc-core/utils/commonUtils"
import produce from "immer"
import { assocPath, clone, filter, find, map, path, paths, pipe, propEq } from "ramda"
import { call, put, select, takeLatest } from "redux-saga/effects"
import str from "utils/strings"
import { SourceMapSalesChannel } from "../../constants"
import { formatHKTimeZone } from "../../utils/formatter"
import { convertCountryToCurrency, processContactInfo } from "../../utils/processCompanyInfo"
import { AppConfig, CompanyLandingInfo, OrderInfo, PackageDetails, PaymentInfo, Query, TCaptchaResult } from "../../utils/selector"
import { isNotEmptyString, isNotNullOrEmpty, isset } from "../../utils/validate"
import { actionTypes, makeAction } from "../actions"
import { checkSupplierApi, createOrderApi, loadCheckOrderApi } from "../apis"
import api from "../apiServices"
import { updatePackageDetailsByOrder } from "./main"
import { loadCities, loadProvinces } from "./region"

export const ChinaToUSD_timestamp = moment("2022-04-01T00:00:00Z").valueOf()

export let landingSagas = [
  takeLatest(actionTypes.LANDING_CREATE_ORDER, createOrder),
  takeLatest(actionTypes.LANDING_UPDATE_ORDER, updateOrder),
  takeLatest(actionTypes.LANDING_CONFIRM_ORDER, confirmOrder),
  takeLatest(actionTypes.LANDING_LOAD_ORDER, loadOrder),
  takeLatest(actionTypes.LANDING_NOTIFY_PASSED_FAILED_LIMIT, notifyPassedFailedLimit)
]

const initialState = {
  companyLandingInfo: {
    email: "",
    nameEN: "",
    nameTC: "",
    nameSC: "",
    contactPerson: {
      title: {
        // code: "Mr",
        // englishDescription: "Mr",
        // chineseDescription: "先生"
      },
      firstName: "",
      lastName: ""
    },
    telephone: {
      // countryCode: {
      //   callCode: 852
      // },
      countryCode: {},
      areaCode: "",
      number: "",
      extension: ""
    },
    address: {
      firstRow: "",
      secondRow: "",
      thirdRow: "",
      fourthRow: ""
    },
    region: {
      country: {},
      state: {},
      city: {}
    },
    natureOfBusiness: [],
    emailLangPef: {},
    saleRepCode: "",
    editSaleRepCode: true,
    provideBRDetails: true,
    BRDetails: {
      number: "",
      commencementDate: null,
      expiryDate: null,
      file: {},
      isPdfType: false
    },
    fromSSO: false,
    SSOUID: ""
  },
  tencentCaptchaResult: {
    ticket: null,
    randstr: null
  },
  orderInfo: {
    orderID: "",
    error: false
  },
  paymentInfo: {
    isTnC: false,
    isAutoRenew: true, //default checkbox ticked
    paymentMethod: null
  },
  timer: {
    isTimesUp: false
  },
  proceedAndConfirm: {
    unClickable: true
  }
}

const subActions = {
  SET_ORDER_INFO: "SET_ORDER_INFO",
  LOAD_ORDER_START: "LOAD_ORDER_START",
  LOAD_ORDER_SUCCESS: "LOAD_ORDER_SUCCESS",
  LOAD_ORDER_FAILED: "LOAD_ORDER_FAILED"
}

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case actionTypes.LANDING_SET_COMPANY_LANDING_INFO:
        Object.assign(draft.companyLandingInfo, action.payload)
        break
      case actionTypes.PAYMENT_INFO:
        Object.assign(draft.paymentInfo, action.payload)
        break
      case actionTypes.TIMER_TIMES_UP:
        Object.assign(draft.timer, action.payload)
        break
      case actionTypes.PORCESS_AND_CONFIRM:
        Object.assign(draft.proceedAndConfirm, action.payload)
        break
      case actionTypes.LANDING_RESET_SELECTED_REGION:
        Object.assign(draft.companyLandingInfo.region, {
          ...state.companyLandingInfo.region,
          ...action.payload
        })
        break
      case actionTypes.REGION_RESET_OPTIONS:
        Object.assign(draft.companyLandingInfo.region, {
          ...state.companyLandingInfo.region,
          ...action.payload.select
        })
        break
      case actionTypes.LANDING_SET_TCAPTCHA_RESULT:
        Object.assign(draft, action.payload)
        break
      case subActions.SET_ORDER_INFO:
        Object.assign(draft, action.payload)
        break
      case actionTypes.LANDING_LOAD_CHECK_ORDER_START:
      case subActions.LOAD_ORDER_START:
        Object.assign(draft.orderInfo, action.payload)
        break
      case actionTypes.LANDING_LOAD_CHECK_ORDER_SUCCESS:
      case subActions.LOAD_ORDER_SUCCESS:
        Object.assign(draft.orderInfo, action.payload)
        break
      case actionTypes.LANDING_LOAD_CHECK_ORDER_FAILED:
      case subActions.LOAD_ORDER_FAILED:
        Object.assign(draft.orderInfo, action.payload)
        break
      case actionTypes.LANDING_CHOSE_PAYMENT_METHOD:
        Object.assign(draft.paymentInfo, action.payload)
        break
      case subActions.FILE_IS_PDF_TYPE:
      case actionTypes.LANDING_SET_BR_FILE:
        Object.assign(draft.companyLandingInfo.BRDetails, action.payload)
        break

      case actionTypes.LANDING_SET_EMAIL:
      case actionTypes.LANDING_SET_NAME_EN:
      case actionTypes.LANDING_SET_NAME_TC:
      case actionTypes.LANDING_SET_NAME_SC:
      case actionTypes.LANDING_SET_SALES_REP_CODE:
      case actionTypes.LANDING_SET_PROVIDE_BR:
      case actionTypes.LANDING_SET_COUNTRY:
      case actionTypes.LANDING_SET_STATE:
      case actionTypes.LANDING_SET_CITY:
      case actionTypes.LANDING_SET_NOB:
      case actionTypes.LANDING_SET_EMAIL_LANG:
        Object.assign(draft.companyLandingInfo, action.payload)
        break
      case actionTypes.LANDING_SET_TITLE:
      case actionTypes.LANDING_SET_FIRST_NAME:
      case actionTypes.LANDING_SET_LAST_NAME:
        Object.assign(draft.companyLandingInfo.contactPerson, action.payload)
        break
      case actionTypes.LANDING_SET_ADDRESS_1:
      case actionTypes.LANDING_SET_ADDRESS_2:
      case actionTypes.LANDING_SET_ADDRESS_3:
      case actionTypes.LANDING_SET_ADDRESS_4:
        Object.assign(draft.companyLandingInfo.address, action.payload)
        break
      case actionTypes.LANDING_SET_COUNTRY_CODE:
      case actionTypes.LANDING_SET_AREA_CODE:
      case actionTypes.LANDING_SET_NUMBER:
      case actionTypes.LANDING_SET_EXTENSION:
        Object.assign(draft.companyLandingInfo.telephone, action.payload)
        break
      case actionTypes.LANDING_SET_BR_NUMBER:
      case actionTypes.LANDING_SET_BR_VALID_START:
      case actionTypes.LANDING_SET_BR_VALID_END:
        Object.assign(draft.companyLandingInfo.BRDetails, action.payload)
        break
    }
  })

const loadOrderStart = (orderID) => makeAction(subActions.LOAD_ORDER_START, { orderID, error: false })
const loadOrderSuccess = (result) => makeAction(subActions.LOAD_ORDER_SUCCESS, { ...result })
const loadOrderFailed = (error) => makeAction(subActions.LOAD_ORDER_FAILED, { error })

export function convertOrderProducts(checkOrder) {
  if (isNotNullOrEmpty(checkOrder?.orderPackages)) return checkOrder.orderPackages
  else if (isNotNullOrEmpty(checkOrder?.orderItems)) return checkOrder.orderItems
  return null
}

export function convertProductDetails(orderPackage) {
  if (isNotNullOrEmpty(orderPackage?.packageDetails)) return orderPackage.packageDetails
  if (isNotNullOrEmpty(orderPackage?.itemDetails)) return orderPackage.itemDetails
  return null
}

export function* loadOrder({ resolve, reject, payload: { orderID, paymentRef, withEndPathCheck = false } }) {
  log("Load Order Start")
  yield put(loadOrderStart(orderID))
  try {
    const params = {
      t: `${Math.random()}`
    }
    const endpoint = withEndPathCheck ? `/orders/${orderID}/check` : `/orders/${orderID}`
    const { data: json } = yield call(() => api.load(endpoint, params))
    log(json)
    yield put(loadOrderSuccess(json))
    yield call(updatePackageDetailsByOrder, json)

    resolve && resolve()
  } catch (err) {
    log(`Error: ${err}`)
    yield put(loadOrderFailed(err))
    reject && reject()
  }
  log("Load Order End")
}

function* handlePrefill(json) {
  log("Handle Prefill Start")
  if (!(json && !isset(json.code))) return
  const { salesCode } = yield select(PackageDetails)
  const companyInfo = yield select(CompanyLandingInfo)
  const queries = yield select(Query)
  const isCheckPRefillExist = isNotNullOrEmpty(json.check) && isNotNullOrEmpty(json.check?.prefill)
  const isSalesCodeExist = isNotEmptyString(salesCode)
  const isQuerySalesCodeExist = queries?.sales && isNotEmptyString(queries.sales)
  let tempCompanyInfo = Object.assign({}, companyInfo)

  if (isCheckPRefillExist || isSalesCodeExist || isQuerySalesCodeExist) {
    if (isQuerySalesCodeExist) {
      tempCompanyInfo = assocPath(["saleRepCode"], queries.sales, tempCompanyInfo)
      tempCompanyInfo = assocPath(["editSaleRepCode"], false, tempCompanyInfo)
    }
    if (isSalesCodeExist) {
      tempCompanyInfo = assocPath(["saleRepCode"], salesCode, tempCompanyInfo)
      tempCompanyInfo = assocPath(["editSaleRepCode"], false, tempCompanyInfo)
    }
    if (isCheckPRefillExist) {
      const appConfig = yield select(AppConfig)
      const nobOptions = path(["nobOptions"], appConfig) || []
      const [CCDID, nameTC, nameSC, callCode, areaCode, number, extension, firstRow, secondRow, thirdRow, fourthRow, natureOfBusiness, countryDetail, provinceDetail, cityDetail] = paths(
        [
          ["companyCcdId"],
          ["companyNameTc"],
          ["companyNameSc"],
          ["telCountryCode"],
          ["telAreaCode"],
          ["telNumber"],
          ["telExt"],
          ["addrLine1"],
          ["addrLine2"],
          ["addrLine3"],
          ["addrLine4"],
          ["bizNature"],
          ["countryDetail"],
          ["provinceDetail"],
          ["cityDetail"]
        ],
        json.check?.prefill
      )

      if (isNotEmptyString(CCDID)) tempCompanyInfo = assocPath(["CCDID"], CCDID, tempCompanyInfo)
      if (isNotEmptyString(nameTC)) tempCompanyInfo = assocPath(["nameTC"], nameTC, tempCompanyInfo)
      if (isNotEmptyString(nameSC)) tempCompanyInfo = assocPath(["nameSC"], nameSC, tempCompanyInfo)
      if (isNotEmptyString(callCode)) tempCompanyInfo = assocPath(["telephone", "countryCode", "callCode"], parseInt(callCode), tempCompanyInfo)
      if (isNotEmptyString(areaCode)) tempCompanyInfo = assocPath(["telephone", "areaCode"], areaCode, tempCompanyInfo)
      if (isNotEmptyString(number)) tempCompanyInfo = assocPath(["telephone", "number"], number, tempCompanyInfo)
      if (isNotEmptyString(extension)) tempCompanyInfo = assocPath(["telephone", "extension"], extension, tempCompanyInfo)
      if (isNotEmptyString(firstRow)) tempCompanyInfo = assocPath(["address", "firstRow"], firstRow, tempCompanyInfo)
      if (isNotEmptyString(secondRow)) tempCompanyInfo = assocPath(["address", "secondRow"], secondRow, tempCompanyInfo)
      if (isNotEmptyString(thirdRow)) tempCompanyInfo = assocPath(["address", "thirdRow"], thirdRow, tempCompanyInfo)
      if (isNotEmptyString(fourthRow)) tempCompanyInfo = assocPath(["address", "fourthRow"], fourthRow, tempCompanyInfo)

      if (isNotNullOrEmpty(countryDetail)) {
        tempCompanyInfo = assocPath(["region", "country"], countryDetail, tempCompanyInfo)
        yield call(loadProvinces, { payload: { countryCode: countryDetail.id } })
      }
      if (isNotNullOrEmpty(provinceDetail)) {
        tempCompanyInfo = assocPath(["region", "state"], provinceDetail, tempCompanyInfo)
        yield call(loadCities, { payload: { provinceCode: provinceDetail.id } })
      }
      if (isNotNullOrEmpty(cityDetail)) tempCompanyInfo = assocPath(["region", "city"], cityDetail, tempCompanyInfo)

      if (isNotNullOrEmpty(natureOfBusiness)) {
        const newNob = pipe(
          map((item) => find(propEq("code", item))(nobOptions)),
          filter(isNotNullOrEmpty)
        )(natureOfBusiness)
        tempCompanyInfo = assocPath(["natureOfBusiness"], newNob, tempCompanyInfo)
      }
    }
    log("tempCompanyInfo")
    log(tempCompanyInfo)
    yield put(makeAction(actionTypes.LANDING_SET_COMPANY_LANDING_INFO, tempCompanyInfo))
  }
  yield put(makeAction(subActions.SET_ORDER_INFO, { orderInfo: json }))
  log("Handle Prefill End")
}

function* convertEligibleToPurchase(data, eligibleToPurchase) {
  return assocPath(["check", "eligibleToPurchase"], eligibleToPurchase, data)
}

function convertPrefill(data, prefill) {
  return assocPath(["check", "prefill"], prefill, data)
}

function skipSupplierChecking(query) {
  let salesChannel = getSalesChannelByQuery(query)
  return salesChannel && salesChannel !== SourceMapSalesChannel["public-form"]
}

function* checkSupplier(companyInfo, query, packageDetails) {
  log("checkSupplier start")
  let data
  try {
    let payload = yield call(convertCheckSupplierPayload, companyInfo, query)
    if (packageDetails?.nameEN) {
      payload.productName = packageDetails.nameEN
    }
    const response = yield call(checkSupplierApi, payload)
    data = response.data
  } catch (err) {
    log(`Error: ${err}`)
  } finally {
    log("checkSupplier end")
    return data
  }
}

function* createOrder({ payload: { onSuccessAction, onFailureAction } }) {
  log("Create Order Start")
  try {
    const companyLandingInfo = yield select((state) => state.landing.companyLandingInfo)
    const packageDetails = yield select((state) => state.main.packageDetails)
    const query = yield select((state) => state.main.query)
    const orderInfo = yield select(OrderInfo)

    let responseData,
      eligibleToPurchase = true
    // if (!skipSupplierChecking(query)) {
    //   responseData = yield call(checkSupplier, companyLandingInfo, query)
    //   eligibleToPurchase = responseData.eligibleToPurchase
    // }

    if (!skipSupplierChecking(query)) {
      responseData = yield call(checkSupplier, companyLandingInfo, query, packageDetails)
      eligibleToPurchase = responseData?.eligibleToPurchase
    }

    let data = {},
      prefillFromCheckSupplierResponse = responseData?.prefill
    if (eligibleToPurchase) {
      let skipCreateOrder = Boolean(orderInfo.id)
      if (!skipCreateOrder) {
        let payload = yield call(convertToStep1Payload, companyLandingInfo, packageDetails, query, prefillFromCheckSupplierResponse)
        log(payload)
        const response = yield call(createOrderApi, payload)
        data = response.data
        data = yield call(convertPrefill, data, prefillFromCheckSupplierResponse)
        log(data)
        yield call(handlePrefill, data)
      } else {
        data = orderInfo
      }
    }
    data = yield call(convertEligibleToPurchase, data, eligibleToPurchase)
    if (onSuccessAction) yield call(onSuccessAction, data)
  } catch (err) {
    log(`Error: ${err}`)
    if (onFailureAction) yield call(onFailureAction, err)
  }
  log("Create Order End")
}

function* getConfigForTCaptchaVerified() {
  let headers = {}
  const tCaptchaResult = yield select(TCaptchaResult)
  if (!isset(tCaptchaResult.ticket)) return {}
  headers["CAPTCHA-TICKET"] = tCaptchaResult.ticket
  if (isset(tCaptchaResult.randstr)) headers["CAPTCHA-RANDSTR"] = tCaptchaResult.randstr
  return { headers }
}

function* updateOrder({ payload: { onSuccessAction, onFailureAction } }) {
  log("Update Order Start")
  try {
    const config = yield call(getConfigForTCaptchaVerified)
    log(`Update Order config:`)
    log(config)
    const params = {
      // t: `${Math.random()}`
    }
    const orderInfo = yield select(OrderInfo)
    const companyInfo = yield select(CompanyLandingInfo)
    let payload = yield call(convertToStep2Payload, companyInfo)
    log(payload)
    yield call(() => api.update(`/orders/${orderInfo.id}`, payload, { ...config, params }))
    let checkOrderResponse = yield call(loadCheckOrderApi, orderInfo.id, { t: `${Math.random()}` })
    let json = checkOrderResponse?.data
    log(json)
    yield put(makeAction(subActions.SET_ORDER_INFO, { orderInfo: json }))
    yield put(makeAction(actionTypes.APP_SKIP_COMING_CHECK_ORDER, { skip: true }))
    if (onSuccessAction) yield call(onSuccessAction, json)
  } catch (err) {
    log(`Error: ${err}`)
    if (onFailureAction) yield call(onFailureAction, err)
  }
  log("Update Order End")
}

function* confirmOrder({ payload: { isAllowAutoRenew, onSuccessAction, onFailureAction } }) {
  log("Confirm Order Start")
  try {
    const info = yield select(PaymentInfo)
    const orderInfo = yield select(OrderInfo)
    const autoRenew = isAllowAutoRenew && isNotNullOrEmpty(info) && info.isAutoRenew
    let data = { status: "CONFIRM", autoRenew, paymentMethod: info.paymentMethod }
    const { data: json } = yield call(() => api.update(`/orders/${orderInfo.id}`, data))
    log(json)
    localStorage.setItem("payment-locale", str.locale)
    if (onSuccessAction) yield call(onSuccessAction, { redirectUrl: json.redirectUrl })
  } catch (err) {
    log(`Error: ${err}`)
    if (onFailureAction) yield call(onFailureAction, err)
  }
  log("Confirm Order End")
}

function* notifyPassedFailedLimit({ payload: { orderID, onSuccessAction, onFailureAction } }) {
  log("Notify Passed Failed Limit Start")
  try {
    const { data: json } = yield call(() => api.create(`/orders/${orderID}/passed_failed_limit`))
    log(json)
    if (onSuccessAction) yield call(onSuccessAction)
  } catch (err) {
    log(`Error: ${err}`)
    if (onFailureAction) yield call(onFailureAction, err)
  }
  log("Notify Passed Failed Limit End")
}

function log(text) {
  console.log("%c Landing ", "color: white; background-color: #fb5004", text)
}

export function checkCanCreateOrder(state) {
  let query = state.main.query
  let packageDetails = state.main.packageDetails
  if (!query.source || !SourceMapSalesChannel[query.source]) return false
  if (!packageDetails.hashID && !packageDetails.idForDisplay) return false
  return true
}

function* convertCheckSupplierPayload(companyInfo, query) {
  let payload = {}
  assignFieldToPayload(payload, companyInfo.email, "email")
  assignFieldToPayload(payload, companyInfo.nameEN, "nameEN")
  if (query?.source) {
    let salesChannel = getSalesChannelByQuery(query)
    assignFieldToPayload(payload, salesChannel, "salesChannel")
  }
  return payload
}

function getSalesChannelByQuery(query) {
  return SourceMapSalesChannel[query.source] || null
}

function* convertToStep1Payload(companyInfo, packageDetails, query, prefill) {
  let payload = {}
  //Base
  assignFieldToPayload(payload, "NEW", "status")
  assignFieldToPayload(payload, "GENERAL", "customerType")
  if (query?.source) {
    let salesChannel = getSalesChannelByQuery(query)
    assignFieldToPayload(payload, salesChannel, "salesChannel")
  }

  //Company Info
  assignFieldToPayload(payload, companyInfo.email, "email")
  assignFieldToPayload(payload, companyInfo.nameEN, "nameEN")
  assignFieldToPayload(payload, companyInfo.nameEN, "soldTo")
  assignFieldToPayload(payload, companyInfo.nameEN, "billTo")
  if (companyInfo.SSOUID?.length && companyInfo.emailFromSSO?.length && companyInfo.emailFromSSO === companyInfo.nameEN) {
    assignFieldToPayload(payload, companyInfo.SSOUID, "SSOUID")
  }

  //Product
  assignFieldToPayload(payload, packageDetails.hashID || packageDetails.idForDisplay, "hashedID")
  assignFieldToPayload(payload, 1, "quantity")
  if (packageDetails?.onlineItemFair?.id) {
    assignFieldToPayload(payload, packageDetails.onlineItemFair.id, "onlineItemFairId")
  }

  //From prefill
  if (prefill) {
    assignFieldToPayload(payload, prefill.companyCcdId, "CCDID")
    assignFieldToPayload(payload, prefill.companyNameTc, "nameTC")
    assignFieldToPayload(payload, prefill.companyNameSc, "nameSC")
    assignFieldToPayload(payload, processTelephoneFromPrefill(prefill), "telephone")
  }
  return payload
}

function processTelephoneFromPrefill(prefill) {
  return {
    countryCode: prefill.telCountryCode || "",
    areaCode: prefill.telAreaCode || "",
    number: prefill.telNumber || "",
    extension: prefill.telExt || ""
  }
}

function* convertToStep2Payload(companyInfo) {
  let payload = {
    status: "DETAIL"
  }
  //Base
  assignFieldToPayload(payload, companyInfo.saleRepCode?.trim(), "salesCode")
  // assignFieldToPayload(payload, convertCountryToCurrency(companyInfo.region?.country?.id), "currency")

  // RMB is not necessary & China need to check USD
  let reviseCurrency = convertCountryToCurrency(companyInfo.region?.country?.id)
  reviseCurrency = reviseCurrency == "RMB" ? "USD" : reviseCurrency
  assignFieldToPayload(payload, reviseCurrency, "currency")

  //Customer
  assignFieldToPayload(payload, processContactInfo(companyInfo), "customer.contact")
  assignFieldToPayload(payload, companyInfo.nameEN, "customer.nameEN")
  assignFieldToPayload(payload, companyInfo.nameTC?.trim(), "customer.nameTC")
  assignFieldToPayload(payload, companyInfo.nameSC?.trim(), "customer.nameSC")
  assignFieldToPayload(payload, null, "customer.businessNatures")
  if (companyInfo.natureOfBusiness?.length) {
    let nobIDs = companyInfo.natureOfBusiness.map((item) => item.code)
    assignFieldToPayload(payload, nobIDs, "customer.businessNatures")
  }
  assignFieldToPayload(payload, companyInfo.region?.country?.id || "", "customer.countryCode")
  assignFieldToPayload(payload, companyInfo.region?.state?.id || "", "customer.provinceCode")
  assignFieldToPayload(payload, companyInfo.region?.city?.id || "", "customer.cityCode")
  assignFieldToPayload(payload, companyInfo.emailLangPef?.lang || "", "customer.emailPreferLang")
  if (companyInfo.CCDID?.trim()?.length) {
    assignFieldToPayload(payload, companyInfo.CCDID.trim(), "customer.CCDID")
  } else {
    assignFieldToPayload(payload, null, "customer.CCDID")
  }

  //BR
  let brPayload = convertBRPayload(companyInfo)
  if (isNotNullOrEmpty(brPayload)) {
    payload.br = brPayload
  }
  return payload
}

function convertBRPayload(companyInfo) {
  let payload = {}
  let brDetails = companyInfo.BRDetails
  let number = brDetails.number?.trim(),
    validStart = brDetails.commencementDate,
    validEnd = brDetails.expiryDate,
    imageUrl = brDetails.file?.result?.url

  if (number?.length) {
    assignFieldToPayload(payload, number, "number")
  }
  if (validStart && isset(formatHKTimeZone(validStart))) {
    assignFieldToPayload(payload, formatHKTimeZone(validStart), "validStart")
  }
  if (validEnd && isset(formatHKTimeZone(validEnd))) {
    assignFieldToPayload(payload, formatHKTimeZone(validEnd), "validEnd")
  }
  if (imageUrl?.length) {
    let filename = brDetails.file?.result?.filename,
      key = brDetails.file?.result?.key
    assignFieldToPayload(payload, { url: imageUrl, filename, key }, "image")
  }
  return payload
}

function assignFieldToPayload(payload, value, fieldPath) {
  let currentNode = payload
  let paths = fieldPath.split(".")
  paths.forEach((path, index) => {
    if (index == paths.length - 1) {
      currentNode[path] = value
    } else {
      if (!currentNode[path]) currentNode[path] = {}
      currentNode = currentNode[path]
    }
  })
  currentNode = value
}

export function includeCountryCode(countryCodes, targetCountryCode) {
  if (targetCountryCode === "HKG") {
    return countryCodes?.some((code) => code == "Hong Kong" || code == "HKG" || code == "ALL" || code == "All")
  } else if (targetCountryCode === "CHN") {
    return countryCodes?.some((code) => code == "China" || code == "CHN" || code == "ALL" || code == "All")
  } else if (targetCountryCode?.length) {
    return countryCodes?.some((code) => code == "Overseas" || code == targetCountryCode || code == "ALL" || code == "All")
  }
  return false
}

export function getEligibleGroupByCountryCode(egs, countryCode) {
  let targetEG = null
  if (egs?.length) {
    for (let i = 0; i < egs.length; i++) {
      let ele = egs[i]
      if (includeCountryCode(ele.countryID, countryCode) && (!targetEG || ele.effectiveStart.localeCompare(targetEG.effectiveStart) <= 0)) {
        targetEG = clone(ele)
      }
    }
  }
  return targetEG
}
